import React from 'react';
import { Field } from 'formik';
import { titleize } from 'inflection';

import styles from './personalDetailsFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const { cities, investmentSituations } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const PersonalDetailsForm = () => {
  const cityNames = cities.map(city => city.name);
  return (
    <div>
      <div className={styles.personalDetailsFormColumn}>
        <Field
          component={InputField}
          name="userProfile.hometown"
          type="select"
          label="Hometown"
          options={cityNames}
          required={false}
        />
        <Field component={InputField} name="userProfile.investmentHero" label="Investment Hero" />
        <Field
          component={InputField}
          name="userProfile.favoriteInvestmentBook"
          label="Favorite Investment Book"
        />
        <Field
          component={InputField}
          name="userProfile.investingStyle"
          type="select"
          label="Investing Style"
          options={investmentSituations.map(titleize)}
          required={false}
        />
        <Field component={InputField} name="userProfile.languagesSpoken" label="Languages Spoken" />
      </div>
    </div>
  );
};

export default PersonalDetailsForm;
